export const declaredProducts = {
  title: '申报产品',
  resourceName: '申报产品',
  titles: {
    list: '申报产品列表',
    detail: '申报产品详情',
    create: '新增申报产品',
    edit: '编辑申报产品',
    addQuick: '快速添加',
  },
  sections: {
    basic: '基本信息',
    audit: '系统',
    linkedInternalProducts: '已关联的内部产品',
  },
  hints: {
    codeStaff: '申报产品编码由员工填写',
  },
  fields: {
    code: '申报产品编码',
    name: '申报产品名称',
    description: '描述',
    note: '备注',
    status: '状态',
    onOffAction: '开 / 关',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
    internalCode: '内部产品编码',
    internalName: '内部产品名称',
    internalProduct: '内部产品',
  },
  status: {
    active: '启用',
    inactive: '停用',
  },
  actions: {
    addInternalProduct: '添加内部产品',
  },
  messages: {
    noData: '暂无申报产品',
    noLinkedProducts: '尚未关联内部产品',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    importSuccess: '导入成功',
    importFailed: '导入失败',
    importDescription: '请使用提供的 Excel 模板导入申报产品（支持与内部产品多对多关联）。',
  },
}
